import { useCallback, useState } from "react";

import type { CosignatureStatus } from "@/core/types";

type CosignatureFilters = {
  status: Nullable<CosignatureStatus>;
  supervisor_id: Nullable<string>;
};

const DEFAULT_FILTERS: CosignatureFilters = {
  status: null,
  supervisor_id: null,
};

export function useCosignatureFilters(initialState: CosignatureFilters) {
  const [state, setState] = useState<CosignatureFilters>(initialState ?? DEFAULT_FILTERS);

  const update = (updates: Partial<CosignatureFilters>) =>
    setState((prev) => ({ ...prev, ...updates }));

  const reset = useCallback(() => setState(DEFAULT_FILTERS), []);

  return [state, update, reset] as const;
}
